import React, {useEffect, useState} from 'react';
import '../scss/components/Profile.scss';
import { useProfileApi } from '../features/auth/hooks/use-profile-api.ts';
import { useProfileContext } from '../features/auth/hooks/use-profile-context.ts';
import DynamicContent from '../components/DynamicContent/DynamicContent.tsx';

export default function Dashboard() {
    const [profileIsLoading, setProfileIsLoading] = useState(true);
    const [salutation, setSalutation] = useState('');
    const { getProfile } = useProfileApi();
    const { needsInitialReview } = useProfileContext();
    useEffect(() => {
        getProfile().then(data => {
            let salutationString:string;
            if (data.payload.personalized_greeting && data.payload.personalized_greeting.length > 0) {
                salutationString = data.payload.personalized_greeting;
                if (!salutationString.endsWith(',')) {
                    salutationString = salutationString + ',';
                }
            } else {
                salutationString = 'Liebe Professionals,';
            }            
            setSalutation(salutationString);
            setProfileIsLoading(false);
        })
    },[]);
    return (
        <div id="dashboard">
            { !profileIsLoading ? (
                <h1 className="h3">{ salutation }</h1>
            ) : <h1 className="h3">&nbsp;</h1> }
            { needsInitialReview ? (
                <DynamicContent title="Dashboard Erstprüfung" />
            ) : (
                <DynamicContent title="Dashboard" />
            ) }
        </div>
    )
}
